var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var BuildTrigger = /** @class */ (function (_super) {
    __extends(BuildTrigger, _super);
    function BuildTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * List all build triggers for a site
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.list = function () {
        return this.rawList().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * List all build triggers for a site
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.rawList = function () {
        return this.client.request({
            method: 'GET',
            url: '/build-triggers',
        });
    };
    /**
     * Retrieve a build trigger
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.find = function (buildTriggerId) {
        return this.rawFind(Utils.toId(buildTriggerId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve a build trigger
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.rawFind = function (buildTriggerId) {
        return this.client.request({
            method: 'GET',
            url: "/build-triggers/".concat(buildTriggerId),
        });
    };
    /**
     * Create build trigger
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.create = function (body) {
        return this.rawCreate(Utils.serializeRequestBody(body, {
            type: 'build_trigger',
            attributes: [
                'name',
                'webhook_token',
                'adapter',
                'indexing_enabled',
                'frontend_url',
                'autotrigger_on_scheduled_publications',
                'adapter_settings',
            ],
            relationships: [],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Create build trigger
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.rawCreate = function (body) {
        return this.client.request({
            method: 'POST',
            url: '/build-triggers',
            body: body,
        });
    };
    /**
     * Update build trigger
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.update = function (buildTriggerId, body) {
        return this.rawUpdate(Utils.toId(buildTriggerId), Utils.serializeRequestBody(body, {
            id: Utils.toId(buildTriggerId),
            type: 'build_trigger',
            attributes: [
                'name',
                'adapter',
                'indexing_enabled',
                'frontend_url',
                'autotrigger_on_scheduled_publications',
                'adapter_settings',
            ],
            relationships: [],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Update build trigger
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.rawUpdate = function (buildTriggerId, body) {
        return this.client.request({
            method: 'PUT',
            url: "/build-triggers/".concat(buildTriggerId),
            body: body,
        });
    };
    /**
     * Trigger a deploy
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/trigger
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.trigger = function (buildTriggerId) {
        return this.rawTrigger(Utils.toId(buildTriggerId));
    };
    /**
     * Trigger a deploy
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/trigger
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.rawTrigger = function (buildTriggerId) {
        return this.client.request({
            method: 'POST',
            url: "/build-triggers/".concat(buildTriggerId, "/trigger"),
        });
    };
    /**
     * Abort a deploy and mark it as failed
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/abort
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.abort = function (buildTriggerId) {
        return this.rawAbort(Utils.toId(buildTriggerId));
    };
    /**
     * Abort a deploy and mark it as failed
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/abort
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.rawAbort = function (buildTriggerId) {
        return this.client.request({
            method: 'DELETE',
            url: "/build-triggers/".concat(buildTriggerId, "/abort"),
        });
    };
    /**
     * Abort a site search spidering and mark it as failed
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/abort_indexing
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.abortIndexing = function (buildTriggerId) {
        return this.rawAbortIndexing(Utils.toId(buildTriggerId));
    };
    /**
     * Abort a site search spidering and mark it as failed
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/abort_indexing
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.rawAbortIndexing = function (buildTriggerId) {
        return this.client.request({
            method: 'DELETE',
            url: "/build-triggers/".concat(buildTriggerId, "/abort_indexing"),
        });
    };
    /**
     * Trigger a new site search spidering of the website
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/reindex
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.reindex = function (buildTriggerId) {
        return this.rawReindex(Utils.toId(buildTriggerId));
    };
    /**
     * Trigger a new site search spidering of the website
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/reindex
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.rawReindex = function (buildTriggerId) {
        return this.client.request({
            method: 'PUT',
            url: "/build-triggers/".concat(buildTriggerId, "/reindex"),
        });
    };
    /**
     * Delete a build trigger
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.destroy = function (buildTriggerId) {
        return this.rawDestroy(Utils.toId(buildTriggerId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Delete a build trigger
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-trigger/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildTrigger.prototype.rawDestroy = function (buildTriggerId) {
        return this.client.request({
            method: 'DELETE',
            url: "/build-triggers/".concat(buildTriggerId),
        });
    };
    BuildTrigger.TYPE = 'build_trigger';
    return BuildTrigger;
}(BaseResource));
export default BuildTrigger;
//# sourceMappingURL=BuildTrigger.js.map